import React from 'react'
import './intro.css'


const Intro = () => {




  return (
<div className="intro_kr">
  <div className="head_kr_intro">
    <span>what we do</span> 
  </div>
  <div className="divider_kr_intro">  </div>
    <div className="todo_kr">
        <div className="sub1_kr">
        <div className="head1_kr">
       <h1>IN A WORLD WHERE DECISIONS ARE MADE IN A MATTER OF SECONDS,
YOU ONLY GET ONE SHOT.</h1>
</div>
<div className="image_kr">
<img src="	https://s3-us-west-2.amazonaws.com/handel-architects/images/_regular/Rowan-11.jpg"/>
        </div>
        </div>
        <div className="vr_divider_kr"></div>
        <div className="sub2_kr">
        <div className="sub2_subdiv_kr" >
            <div className="para1_kr">
           
<p><span>↳ </span>  Whether you’re targeting investors, customers or users, you not only have to get to the point quickly, you have to give them a reason to believe you’re about to make their lives better, or at least make life itself better.</p>
            </div>
            <div className="para2_kr">
            <p>Strong strategic core messaging is what lies behind that strong first impression.</p>
            </div>
       
            </div>
           <div className="divider2_kr" ></div>
           <div className="context2_kr" >
            <h1>WE PARTNER WITH AMBITIOUS FOUNDERS AND EXECUTIVE TEAMS
WHO WANT TO STAND OUT AND GO BIG.</h1>
            </div>

        </div>
    </div>
    <div className="divider2_kr" ></div>

  
</div>
  
  )
  

}

export default Intro